import { useQueryClient } from '@tanstack/react-query';

import { PackPopupType } from '@nf/types/promotion';
import { packPopupStatesService } from '@/features/promotion/cwc-risk-free-bet/services/pack-popup-states.service';
import { useUpdatePackPopupStates } from '@/features/promotion/cwc-risk-free-bet/hooks/use-update-pack-popup-states';

export const useDismissPopupStates = () => {
	const queryClient = useQueryClient();
	const mutation = useUpdatePackPopupStates();

	return {
		dismissPopupStates: (popupTypes: PackPopupType) => {
			mutation.mutate([popupTypes], {
				onSuccess: () => {
					packPopupStatesService.optimisticallyUpdatePackPopupStates(queryClient, [popupTypes]);
				},
				onError: (error: unknown) => {
					console.error('Failed to remove badge:', error);
				}
			});
		}
	};
};